module.exports = __webpack_public_path__ + "static/media/olake-product-3.542c5d9d.svg";